import React from "react";
import NavigationDrawer from "../../components/navigationDrawer";
import { Typography, Container } from "@mui/material";
import { allColors } from "../../constants";
import "../tableStyle.css";

const data = [
  { id: 1, name: "Calls to landline (01,02 & 03)", value: "4p" },
  { id: 2, name: "Calls to major mobile networks", value: "16p" },
  { id: 3, name: "Connection charge – Landline", value: "18p" },
  { id: 3, name: "Connection charge – Mobile", value: "20p" },
];

const CallCharges = () => {
  return (
    <NavigationDrawer>
      <Container
        sx={{
          maxWidth: "1400px !important",
          marginTop: "80px",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Raleway",
            fontSize: { xs: "20px", sm: "35", md: "55px" },
            color: allColors.jetBlack,
            fontWeight: "400",
            marginBottom: "30px",
            textAlign: "center",
          }}
        >
          Call Charges
        </Typography>

        <table className="simple-table">
          <thead>
            <tr>
              <th>Call Charges – Pay as you go only</th>
              <th>Per minute</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Container>
    </NavigationDrawer>
  );
};

export default CallCharges;
